module.exports = __webpack_public_path__ + "assets/img/churn-group.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/churn-group.svg
// module id = 609
// module chunks = 0